import React from 'react';
import __ from "../../../i18n";
import InlineEditor from "../inline-editor/InlineEditor";
import ImageHelper from "../../../helpers/ImageHelper";


function getColumnConfigs({updateItem, refreshData}) {
    return [
        {
            key: 'id',
            name: __('ID'),
            sortable: true
        },
        {
            key: '*image',
            name: __('Image'),
            sortable: false,
            renderValue: (_, item) => {
                return <img src={ImageHelper.getUrl(item)} alt={item.title}/>;
            }
        },
        {
            key: 'title',
            name: __('Title'),
            sortable: true,
            renderEditor: (item, onSubmittingChange, close) => {
                return <InlineEditor
                    item={item}
                    updateItem={updateItem}
                    close={close}
                />;
            }
        },
        {
            key: 'mime_type',
            name: __('Mime type'),
            sortable: true
        },
        {
            key: 'width',
            name: __('Width'),
            sortable: true
        },
        {
            key: 'height',
            name: __('Height'),
            sortable: true
        },
        {
            key: 'aspect_ratio',
            name: __('Aspect ratio'),
            sortable: true
        },

    ];
}

export default {
    getColumnConfigs
};
